import { Facebook, Instagram, Twitter } from 'lucide-react'
import * as m from '~/paraglide/messages'
import { createFieldValidators } from '~/shared/lib/form-utils'
import { updateSocialLinksSchema } from '~/shared/types'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/shared/ui/card'
import { FormInput } from '~/shared/ui/form'

interface SocialLinksSectionProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form API is dynamically typed
  form: any
}

export function SocialLinksSection({ form }: SocialLinksSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{m.socialMedia()}</CardTitle>
        <CardDescription>{m.connectYourSocialMediaProfiles()}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <form.Field
          name="facebook"
          validators={createFieldValidators(updateSocialLinksSchema.shape.facebook)}
        >
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <div className="flex items-center gap-3">
              <Facebook className="w-5 h-5 text-muted-foreground" />
              <div className="flex-1">
                <FormInput
                  field={field}
                  label={m.facebook()}
                  type="url"
                  placeholder={m.httpsfacebookcomyourpage()}
                  optional
                />
              </div>
            </div>
          )}
        </form.Field>

        <form.Field
          name="instagram"
          validators={createFieldValidators(updateSocialLinksSchema.shape.instagram)}
        >
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <div className="flex items-center gap-3">
              <Instagram className="w-5 h-5 text-muted-foreground" />
              <div className="flex-1">
                <FormInput
                  field={field}
                  label={m.instagram()}
                  type="url"
                  placeholder={m.httpsinstagramcomyourprofile()}
                  optional
                />
              </div>
            </div>
          )}
        </form.Field>

        <form.Field
          name="twitter"
          validators={createFieldValidators(updateSocialLinksSchema.shape.twitter)}
        >
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <div className="flex items-center gap-3">
              <Twitter className="w-5 h-5 text-muted-foreground" />
              <div className="flex-1">
                <FormInput
                  field={field}
                  label={m.twitter()}
                  type="url"
                  placeholder={m.httpstwittercomyourhandle()}
                  optional
                />
              </div>
            </div>
          )}
        </form.Field>
      </CardContent>
    </Card>
  )
}
